/*
 *  -----------------------------------------------------------------------
 *    <copyright file="study-visit-schedules.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { Tabs } from '@mui/material';
import Tab from '@mui/material/Tab';
import React, { useState } from 'react';
import { useLocalState, useTranslation, useAuthorization } from 'hooks';
import PageTitle from 'views/components/core/page-title/page-title';
import AdminStudyCohorts from 'views/pages/admin/study/admin-study-cohorts';
import AdminStudyTreatmentArms from 'views/pages/admin/study/admin-study-treatment-arms';
import AdminStudyVisitSchedules from 'views/pages/admin/study/admin-study-visit-schedules/admin-study-visit-schedules';
import Constants from '@utils/constants';

const AdminSubjectVisitSchedules = () => {
    const { state: localState } = useLocalState();
    const studyId = localState.selectedStudy?.id;
    const user = useAuthorization();
    const canEdit = user.canWriteSystemAdminLevel();
    const isSysAdmin = user.isSystemAdmin(Constants.SystemAdminLevel.SysAdmin);

    const { t } = useTranslation();
    const [active, setActive] = useState(0);

    if (!studyId) return <h3>{t('common:noStudySelected')}</h3>;

    return (
        <>
            <div className="mb-15">
                <PageTitle text={t('admin:manageSubjectVisitSchedules')} />
            </div>
            <div className="mb-10">
                <Tabs value={active} onChange={(e: any, value: any) => setActive(value)}>
                    <Tab
                        style={{ fontSize: 16, minWidth: 50 }}
                        label={t('admin:visitSchedulesTitle')}
                        id="visit-schedules-tab"
                        data-testid="visit-schedules-tab"
                    />
                    <Tab
                        style={{ fontSize: 16, minWidth: 50 }}
                        label={t('admin:treatmentArms')}
                        id="treatment-arms-tab"
                        data-testid="treatment-arms-tab"
                    />
                    <Tab
                        style={{ fontSize: 16, minWidth: 50 }}
                        label={t('common:Cohorts')}
                        id="cohorts-tab"
                        data-testid="cohorts-tab"
                    />
                </Tabs>
            </div>

            {active === 0 && <AdminStudyVisitSchedules studyId={studyId} canEdit={canEdit} isSysAdmin={isSysAdmin} />}
            {active === 1 && <AdminStudyTreatmentArms studyId={studyId} canEdit={canEdit} />}
            {active === 2 && <AdminStudyCohorts studyId={studyId} canEdit={canEdit} />}
        </>
    );
};

export default AdminSubjectVisitSchedules;
